// src/App.tsx
import React, { useEffect } from "react";
import "./App.css";

import NavComponent from "./components/Nav/NavComponent";
import MainComponent from "./components/MainContent/MainComponent";
import PartnersComponent from "./components/Partners/PartnersComponent";
import FooterComponent from "./components/Footer/FooterComponent";

import AOS from "aos";
import "aos/dist/aos.css";

import { ParallaxProvider } from "react-scroll-parallax";
import ParallaxBackground from "./components/ParallaxBackground/ParallaxBackground";

import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import HeaderComponent from "./components/Header/HeaderComponent";
import ToolsComponent from "./components/Tools/ToolsComponent";
import CalendarComponent from "./components/For_Students/CalendarComponent";
import NewsComponent from "./components/News/NewsComponent";
import SingleNewsComponent from "./components/News/SingleNewsComponent";
import PostsComponent from "./components/Posts/PostsComponent";
import ClubLogosBar from "./common/components/ClubLogosBar";
import AboutUs from "./components/nav_sites/about_us";
import ContactPage from "./components/nav_sites/contact";
import ProjectsPage from "./components/nav_sites/projects";
import ProjectCategoryPage from "./components/nav_sites/ProjectCategoryPage";
import BusinessPage from "./components/nav_sites/business";
import InternshipsPage from "./components/nav_sites/internships";
import EnvironmentPage from "./components/nav_sites/environment";
import ClubsPage from "./components/nav_sites/clubs";
import TacticalPanelPage from "./components/nav_sites/tactical_panel";
import ProposalsPage from "./components/nav_sites/proposals";
import ReportsPage from "./components/nav_sites/reports";
import CookieConsent from "./common/components/CookieConsent";
import { I18nProvider } from "./i18n/I18nProvider";
import AnalyticsManager from "./common/components/AnalyticsManager";

// Komponent do przewijania na górę przy zmianie trasy
function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    AOS.init({
      //   disable: "phone",
      duration: 700,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <I18nProvider>
    <BrowserRouter>
      <AnalyticsManager />
      <ScrollToTop />
      <ParallaxProvider>
        <div className="App">
          <a className="skip-link" href="#main-content">Przejdź do treści</a>
          <ParallaxBackground />
          <NavComponent />

          <main id="main-content" className="container" tabIndex={-1}>
            <Routes>
              
              <Route
                path="/"
                element={
                  <>
                    <PostsComponent></PostsComponent>
                    <MainComponent />
                    <PartnersComponent />
                    <ClubLogosBar showHeader />
                    <FooterComponent />
                  </>
                }
              />

              <Route
                path="/o_centrum/o_nas"
                element={<AboutUs></AboutUs>}
              />
              <Route
                path="/projekty/aktualne"
                element={<ProjectsPage />}
              />
              <Route
                path="/projekty/cyberbezpieczenstwo-i-przestepczosc-cyfrowa"
                element={<ProjectCategoryPage categoryId="cybercrime" />}
              />
              <Route
                path="/projekty/bezpieczenstwo-publiczne-i-infrastruktura-krytyczna"
                element={<ProjectCategoryPage categoryId="public-safety" />}
              />
              <Route
                path="/projekty/spoleczenstwo-cyfrowe-kultura-i-regulacje"
                element={<ProjectCategoryPage categoryId="digital-society" />}
              />
              <Route
                path="/projekty/transformacja-cyfrowa-innowacje-i-wspolpraca"
                element={<ProjectCategoryPage categoryId="digital-transformation" />}
              />
              <Route
                path="/projekty/archiwum"
                element={<div>Archiwum projektów – WIP</div>}
              />
              <Route
                path="/kontakt"
                element={<ContactPage />}
              />
              <Route
                path="/biznes"
                element={<BusinessPage />}
              />
              <Route
                path="/praktyki"
                element={<InternshipsPage />}
              />
              <Route
                path="/otoczenie"
                element={<EnvironmentPage />}
              />
              <Route
                path="/kola-naukowe"
                element={<ClubsPage />}
              />
              <Route
                path="/panel-taktyczny"
                element={<TacticalPanelPage />}
              />
              <Route
                path="/raporty"
                element={<ReportsPage />}
              />
              <Route
                path="/Raporty"
                element={<ReportsPage />}
              />
              <Route
                path="/aktualnosci"
                element={<NewsComponent />}
              />
              <Route
                path="/aktualnosci/:id"
                element={<SingleNewsComponent />}
              />
              <Route
                path="/student/kalendarz"
                element={<CalendarComponent></CalendarComponent>}
              />
              <Route
                path="/student/propozycje"
                element={<ProposalsPage />}
              />
            </Routes>
          </main>
        </div>
          <CookieConsent />
      </ParallaxProvider>
    </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
